import { useEffect } from 'react'
import { useLocation } from 'react-router'

/** Reset document routes; the app shell owns its separate scroll container. */
export function RouteScrollReset() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}
